export const whenQuestions = [
  {
    questionNumber: 1,
    questionText: "When is the company's annual conference?",
    choices: {
      A: "It's in October every year.",
      B: "Many people attend the conference.",
      C: "The venue has been changed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회사의 연례 컨퍼런스는 언제인가요?",
      choices: {
        A: "매년 10월입니다.",
        B: "많은 사람들이 컨퍼런스에 참석합니다.",
        C: "행사 장소가 변경되었습니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. A는 '매년 10월'이라는 구체적인 일정을 명시하고 있습니다.",
  },
  {
    questionNumber: 2,
    questionText: "When does the new policy take effect?",
    choices: {
      A: "Next Monday, according to the announcement.",
      B: "The HR team proposed the changes.",
      C: "I reviewed the policy document yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새로운 정책은 언제부터 시행되나요?",
      choices: {
        A: "공지에 따르면 다음 주 월요일부터입니다.",
        B: "인사팀이 변경사항을 제안했습니다.",
        C: "어제 정책 문서를 검토했습니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. A는 '다음 주 월요일'이라는 구체적인 시행 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 3,
    questionText: "When are the applications being reviewed?",
    choices: {
      A: "Many people applied for the position.",
      B: "Next Monday.",
      C: "The HR team handles applications.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "지원서는 언제 검토되나요?",
      choices: {
        A: "많은 사람들이 이 직책에 지원했습니다.",
        B: "다음 주 월요일입니다.",
        C: "인사팀이 지원서를 처리합니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. B는 '다음 주 월요일'이라는 구체적인 검토 일정을 명시하고 있습니다.",
  },
  {
    questionNumber: 4,
    questionText: "When is the product release date?",
    choices: {
      A: "It's scheduled for next Friday.",
      B: "The new product has many features.",
      C: "The marketing team is working on the campaign.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "제품 출시일은 언제인가요?",
      choices: {
        A: "다음 주 금요일로 예정되어 있습니다.",
        B: "새 제품에는 많은 기능이 있습니다.",
        C: "마케팅팀이 캠페인을 준비하고 있습니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. A는 '다음 주 금요일'이라는 구체적인 출시 일정을 명시하고 있습니다.",
  },
  {
    questionNumber: 5,
    questionText: "When is the next performance review?",
    choices: {
      A: "The review process is important.",
      B: "You can find the schedule on the HR website.",
      C: "Employees receive performance feedback.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "다음 성과 평가는 언제인가요?",
      choices: {
        A: "평가 과정은 중요합니다.",
        B: "HR 웹사이트에서 일정을 확인하실 수 있습니다.",
        C: "직원들은 성과에 대한 피드백을 받습니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. B는 일정을 확인할 수 있는 방법을 안내하며 적절한 답변을 제공하고 있습니다.",
  },
  {
    questionNumber: 6,
    questionText: "When is the report submission deadline?",
    choices: {
      A: "The deadline is posted on the internal portal.",
      B: "The report should be well-structured.",
      C: "I finished my report last week.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "보고서 제출 마감일이 언제인가요?",
      choices: {
        A: "마감일은 사내 포털에 게시되어 있습니다.",
        B: "보고서는 잘 구성되어야 합니다.",
        C: "저는 지난주에 보고서를 완성했습니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. A는 마감일을 확인할 수 있는 방법을 안내하며 적절한 답변을 제공하고 있습니다.",
  },
  {
    questionNumber: 7,
    questionText: "When are the financial statements released?",
    choices: {
      A: "The finance department manages the reports.",
      B: "Our company has stable revenue.",
      C: "They are published at the end of each quarter.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "재무제표는 언제 발표되나요?",
      choices: {
        A: "재무부서가 보고서를 관리합니다.",
        B: "우리 회사는 안정적인 수익을 보이고 있습니다.",
        C: "매 분기 말에 발행됩니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. C는 '매 분기 말'이라는 구체적인 발행 일정을 명시하고 있습니다.",
  },
  {
    questionNumber: 8,
    questionText: "When is the last day to register for the seminar?",
    choices: {
      A: "Registration closes this Friday.",
      B: "The seminar will be very informative.",
      C: "The seminar takes place in New York.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "세미나 등록 마감일이 언제인가요?",
      choices: {
        A: "이번 주 금요일에 등록이 마감됩니다.",
        B: "세미나는 매우 유익할 것입니다.",
        C: "세미나는 뉴욕에서 열립니다.",
      },
    },
    explanation:
      "When 의문문에서는 구체적인 시간이나 날짜를 답변해야 합니다. A는 '이번 주 금요일'이라는 구체적인 마감일을 명시하고 있습니다.",
  },
  {
    questionNumber: 9,
    questionText: "When was the last staff meeting?",
    choices: {
      A: "Meetings are usually on Mondays.",
      B: "It was held two weeks ago.",
      C: "The meeting is scheduled for next Friday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "마지막 직원 회의는 언제였나요?",
      choices: {
        A: "회의는 보통 월요일에 있습니다.",
        B: "2주 전에 열렸습니다.",
        C: "회의는 다음 주 금요일로 예정되어 있습니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. B는 '2주 전'이라는 과거의 구체적인 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 10,
    questionText: "When was the company founded?",
    choices: {
      A: "It was established in 1995.",
      B: "The company has many employees.",
      C: "We will celebrate the anniversary next year.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회사는 언제 설립되었나요?",
      choices: {
        A: "1995년에 설립되었습니다.",
        B: "회사에는 많은 직원들이 있습니다.",
        C: "우리는 내년에 기념일을 축하할 것입니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. A는 '1995년'이라는 구체적인 설립 연도를 명시하고 있습니다.",
  },
  {
    questionNumber: 11,
    questionText: "When was the new software installed?",
    choices: {
      A: "The IT team is working on another update.",
      B: "The software includes new features.",
      C: "It was updated last Friday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "새로운 소프트웨어는 언제 설치되었나요?",
      choices: {
        A: "IT팀이 다른 업데이트를 진행하고 있습니다.",
        B: "소프트웨어에는 새로운 기능들이 포함되어 있습니다.",
        C: "지난 금요일에 업데이트되었습니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. C는 '지난 금요일'이라는 구체적인 설치 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 12,
    questionText: "When was the contract signed?",
    choices: {
      A: "The legal team reviews all contracts.",
      B: "The client will sign the new agreement soon.",
      C: "It was finalized last month.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "계약서는 언제 서명되었나요?",
      choices: {
        A: "법무팀이 모든 계약서를 검토합니다.",
        B: "고객이 곧 새로운 계약서에 서명할 것입니다.",
        C: "지난달에 완료되었습니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. C는 '지난달'이라는 구체적인 계약 체결 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 13,
    questionText: "When was the product launched?",
    choices: {
      A: "It was introduced in March.",
      B: "The product is very popular.",
      C: "The marketing team is promoting it.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "제품은 언제 출시되었나요?",
      choices: {
        A: "3월에 출시되었습니다.",
        B: "제품이 매우 인기가 있습니다.",
        C: "마케팅팀이 홍보를 하고 있습니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. A는 '3월'이라는 구체적인 출시 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 14,
    questionText: "When was the last performance review?",
    choices: {
      A: "Employees receive regular feedback.",
      B: "The HR team organizes training sessions.",
      C: "It was conducted in June.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "마지막 성과 평가는 언제였나요?",
      choices: {
        A: "직원들은 정기적으로 피드백을 받습니다.",
        B: "인사팀이 교육 세션을 준비합니다.",
        C: "6월에 실시되었습니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. C는 '6월'이라는 구체적인 평가 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 15,
    questionText: "When was the last update to the company policy?",
    choices: {
      A: "It was revised in January.",
      B: "The policy applies to all employees.",
      C: "The HR department handles policy changes.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회사 정책은 마지막으로 언제 업데이트되었나요?",
      choices: {
        A: "1월에 개정되었습니다.",
        B: "정책은 모든 직원들에게 적용됩니다.",
        C: "인사부서가 정책 변경을 담당합니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. A는 '1월'이라는 구체적인 개정 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 16,
    questionText: "When was the last customer satisfaction survey conducted?",
    choices: {
      A: "Customers give feedback regularly.",
      B: "The company values customer opinions.",
      C: "It was done three months ago.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "마지막 고객 만족도 조사는 언제 실시되었나요?",
      choices: {
        A: "고객들은 정기적으로 피드백을 제공합니다.",
        B: "회사는 고객 의견을 중요하게 생각합니다.",
        C: "3개월 전에 실시되었습니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. C는 '3개월 전'이라는 구체적인 조사 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 17,
    questionText: "When was the product launched?",
    choices: {
      A: "The next launch will be in October.",
      B: "Right after the marketing campaign ended.",
      C: "The product is very popular now.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "제품은 언제 출시되었나요?",
      choices: {
        A: "다음 출시는 10월이 될 것입니다.",
        B: "마케팅 캠페인이 끝난 직후였습니다.",
        C: "제품이 현재 매우 인기가 있습니다.",
      },
    },
    explanation:
      "When was(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. B는 '마케팅 캠페인이 끝난 직후'라는 관련 이벤트를 기준으로 한 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 18,
    questionText: "When did you submit the report?",
    choices: {
      A: "I sent it yesterday afternoon.",
      B: "The report is 10 pages long.",
      C: "The manager will review it soon.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "보고서를 언제 제출하셨나요?",
      choices: {
        A: "어제 오후에 보냈습니다.",
        B: "보고서는 10페이지입니다.",
        C: "매니저가 곧 검토할 것입니다.",
      },
    },
    explanation:
      "When did(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. A는 '어제 오후'라는 구체적인 제출 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 19,
    questionText: "When did the client sign the contract?",
    choices: {
      A: "It was signed two weeks ago.",
      B: "The contract includes a confidentiality clause.",
      C: "We will discuss contract details tomorrow.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "고객이 계약서에 언제 서명했나요?",
      choices: {
        A: "2주 전에 서명되었습니다.",
        B: "계약서에는 기밀유지 조항이 포함되어 있습니다.",
        C: "내일 계약 세부사항을 논의할 것입니다.",
      },
    },
    explanation:
      "When did(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. A는 '2주 전'이라는 구체적인 서명 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 20,
    questionText: "When does the store open?",
    choices: {
      A: "I went there last weekend.",
      B: "It opens at 9 AM every day.",
      C: "The store sells electronics.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "가게는 언제 여나요?",
      choices: {
        A: "저는 지난 주말에 그곳에 갔습니다.",
        B: "매일 오전 9시에 엽니다.",
        C: "가게는 전자제품을 팝니다.",
      },
    },
    explanation:
      "When does(현재형) 의문문에서는 현재의 정기적인 시간이나 일정을 답변해야 합니다. B는 '매일 오전 9시'라는 구체적인 개점 시간을 명시하고 있습니다.",
  },
  {
    questionNumber: 21,
    questionText: "When does the next training session start?",
    choices: {
      A: "The training lasts for three hours.",
      B: "Many employees attend training sessions.",
      C: "It begins on Wednesday morning.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "다음 교육 세션은 언제 시작하나요?",
      choices: {
        A: "교육은 3시간 동안 진행됩니다.",
        B: "많은 직원들이 교육 세션에 참석합니다.",
        C: "수요일 아침에 시작합니다.",
      },
    },
    explanation:
      "When does(현재형) 의문문에서는 예정된 시간이나 일정을 답변해야 합니다. C는 '수요일 아침'이라는 구체적인 시작 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 22,
    questionText: "When did the manager announce the new policy?",
    choices: {
      A: "The new policy applies to all employees.",
      B: "The HR department handles policy changes.",
      C: "He made the announcement last Friday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "매니저가 새로운 정책을 언제 발표했나요?",
      choices: {
        A: "새로운 정책은 모든 직원들에게 적용됩니다.",
        B: "인사부서가 정책 변경을 담당합니다.",
        C: "지난 금요일에 발표했습니다.",
      },
    },
    explanation:
      "When did(과거형) 의문문에서는 과거의 구체적인 시간이나 날짜를 답변해야 합니다. C는 '지난 금요일'이라는 구체적인 발표 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 23,
    questionText: "When do employees need to submit their expense reports?",
    choices: {
      A: "By the 10th of every month.",
      B: "The finance team reviews all reports.",
      C: "Employees must attach receipts.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "직원들은 경비 보고서를 언제까지 제출해야 하나요?",
      choices: {
        A: "매월 10일까지입니다.",
        B: "재무팀이 모든 보고서를 검토합니다.",
        C: "직원들은 영수증을 첨부해야 합니다.",
      },
    },
    explanation:
      "When do(현재형) 의문문에서는 정기적인 시간이나 기한을 답변해야 합니다. A는 '매월 10일까지'라는 구체적인 제출 기한을 명시하고 있습니다.",
  },
  {
    questionNumber: 24,
    questionText: "When will the next company meeting take place?",
    choices: {
      A: "The meeting agenda was sent yesterday.",
      B: "The manager led the last meeting.",
      C: "It's scheduled for next Wednesday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "다음 회사 회의는 언제 열릴 예정인가요?",
      choices: {
        A: "회의 안건은 어제 발송되었습니다.",
        B: "매니저가 지난 회의를 주재했습니다.",
        C: "다음 주 수요일로 예정되어 있습니다.",
      },
    },
    explanation:
      "When will(미래형) 의문문에서는 미래의 구체적인 시간이나 날짜를 답변해야 합니다. C는 '다음 주 수요일'이라는 구체적인 예정 일정을 명시하고 있습니다.",
  },
  {
    questionNumber: 25,
    questionText: "When should I book my flight for the conference?",
    choices: {
      A: "The flight duration is about six hours.",
      B: "You should book it at least a month in advance.",
      C: "The conference will be held in New York.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "컨퍼런스를 위한 항공권을 언제 예약해야 하나요?",
      choices: {
        A: "비행 시간은 약 6시간입니다.",
        B: "최소 한 달 전에 예약하셔야 합니다.",
        C: "컨퍼런스는 뉴욕에서 열립니다.",
      },
    },
    explanation:
      "When should(권고형) 의문문에서는 권장되는 시점이나 기한을 답변해야 합니다. B는 '최소 한 달 전'이라는 구체적인 권장 예약 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 26,
    questionText: "When can we expect the final report?",
    choices: {
      A: "Many employees worked on the report.",
      B: "It should be completed by next week.",
      C: "The report was reviewed last month.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "최종 보고서는 언제쯤 받아볼 수 있나요?",
      choices: {
        A: "많은 직원들이 보고서 작성에 참여했습니다.",
        B: "다음 주까지 완성될 예정입니다.",
        C: "보고서는 지난달에 검토되었습니다.",
      },
    },
    explanation:
      "When can(가능성) 의문문에서는 예상되는 시점이나 기한을 답변해야 합니다. B는 '다음 주까지'라는 구체적인 예상 완료 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 27,
    questionText: "When will the product be available for purchase?",
    choices: {
      A: "Customers are excited about the new product.",
      B: "The product is made from high-quality materials.",
      C: "It will be released in early June.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "제품은 언제부터 구매가 가능한가요?",
      choices: {
        A: "고객들이 새 제품에 대해 기대하고 있습니다.",
        B: "제품은 고품질 재료로 만들어졌습니다.",
        C: "6월 초에 출시될 예정입니다.",
      },
    },
    explanation:
      "When will(미래형) 의문문에서는 미래의 구체적인 시간이나 날짜를 답변해야 합니다. C는 '6월 초'라는 구체적인 출시 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 28,
    questionText: "When can employees start using the new system?",
    choices: {
      A: "After the IT team completes testing.",
      B: "The system was developed last year.",
      C: "The new system has improved security.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "직원들은 새로운 시스템을 언제부터 사용할 수 있나요?",
      choices: {
        A: "IT팀이 테스트를 완료한 후부터입니다.",
        B: "시스템은 작년에 개발되었습니다.",
        C: "새로운 시스템은 보안이 강화되었습니다.",
      },
    },
    explanation:
      "When can(가능성) 의문문에서는 가능한 시점이나 조건을 답변해야 합니다. A는 'IT팀의 테스트 완료 후'라는 구체적인 사용 가능 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 29,
    questionText: "When should we follow up with the client?",
    choices: {
      A: "We value our client relationships.",
      B: "After they review our proposal.",
      C: "The client visited our office last month.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객과 언제 후속 연락을 해야 하나요?",
      choices: {
        A: "우리는 고객과의 관계를 소중히 여깁니다.",
        B: "그들이 우리의 제안서를 검토한 후입니다.",
        C: "고객이 지난달에 우리 사무실을 방문했습니다.",
      },
    },
    explanation:
      "When should(권고형) 의문문에서는 권장되는 시점이나 조건을 답변해야 합니다. B는 '제안서 검토 후'라는 구체적인 후속 조치 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 30,
    questionText: "When are you leaving for the business trip?",
    choices: {
      A: "I'm leaving on Thursday morning.",
      B: "I have a lot of meetings this week.",
      C: "The business trip will be productive.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "출장은 언제 출발하시나요?",
      choices: {
        A: "목요일 아침에 출발합니다.",
        B: "이번 주에 회의가 많습니다.",
        C: "출장은 생산적일 것입니다.",
      },
    },
    explanation:
      "When are(현재진행형) 의문문에서는 예정된 시간이나 일정을 답변해야 합니다. A는 '목요일 아침'이라는 구체적인 출발 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 31,
    questionText: "When is the company holding its annual general meeting?",
    choices: {
      A: "The finance team is preparing the reports.",
      B: "It's taking place in early October.",
      C: "The company has many shareholders.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회사는 연례 총회를 언제 개최하나요?",
      choices: {
        A: "재무팀이 보고서를 준비하고 있습니다.",
        B: "10월 초에 열립니다.",
        C: "회사에는 많은 주주들이 있습니다.",
      },
    },
    explanation:
      "When is(현재형) 의문문에서는 예정된 시간이나 일정을 답변해야 합니다. B는 '10월 초'라는 구체적인 회의 일정을 명시하고 있습니다.",
  },
  {
    questionNumber: 32,
    questionText: "When is the restaurant opening its new branch?",
    choices: {
      A: "The restaurant serves international cuisine.",
      B: "Many customers visit this restaurant.",
      C: "It's opening in December.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "레스토랑은 새 지점을 언제 오픈하나요?",
      choices: {
        A: "레스토랑은 세계 각국의 요리를 제공합니다.",
        B: "많은 고객들이 이 레스토랑을 방문합니다.",
        C: "12월에 오픈합니다.",
      },
    },
    explanation:
      "When is(현재형) 의문문에서는 예정된 시간이나 일정을 답변해야 합니다. C는 '12월'이라는 구체적인 개점 일정을 명시하고 있습니다.",
  },
  {
    questionNumber: 33,
    questionText: "When have you last updated your resume?",
    choices: {
      A: "A few months ago, when I applied for a new position.",
      B: "I have several years of work experience.",
      C: "The HR department reviews applications weekly.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이력서를 마지막으로 언제 업데이트하셨나요?",
      choices: {
        A: "새로운 직책에 지원했을 때인 몇 달 전입니다.",
        B: "저는 수년간의 업무 경험이 있습니다.",
        C: "인사부서는 매주 지원서를 검토합니다.",
      },
    },
    explanation:
      "When have(현재완료형) 의문문에서는 과거의 구체적인 시점이나 경험을 답변해야 합니다. A는 '새로운 직책 지원 시점인 몇 달 전'이라는 구체적인 업데이트 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 34,
    questionText: "When has the company revised its policy?",
    choices: {
      A: "The HR team manages policy updates.",
      B: "It was changed earlier this year.",
      C: "Employees must follow company policies.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회사가 정책을 언제 수정했나요?",
      choices: {
        A: "인사팀이 정책 업데이트를 관리합니다.",
        B: "올해 초에 변경되었습니다.",
        C: "직원들은 회사 정책을 따라야 합니다.",
      },
    },
    explanation:
      "When has(현재완료형) 의문문에서는 과거의 구체적인 시점이나 경험을 답변해야 합니다. B는 '올해 초'라는 구체적인 정책 변경 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 35,
    questionText: "When have you renewed your passport?",
    choices: {
      A: "A passport is required for international travel.",
      B: "I need to renew my passport next month.",
      C: "I renewed it last summer.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "여권을 언제 갱신하셨나요?",
      choices: {
        A: "여권은 해외여행에 필요합니다.",
        B: "다음 달에 여권을 갱신해야 합니다.",
        C: "작년 여름에 갱신했습니다.",
      },
    },
    explanation:
      "When have(현재완료형) 의문문에서는 과거의 구체적인 시점이나 경험을 답변해야 합니다. C는 '작년 여름'이라는 구체적인 갱신 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 36,
    questionText: "When have you last attended a training session?",
    choices: {
      A: "I attended one last month.",
      B: "Employees receive training regularly.",
      C: "The training session lasted for three hours.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "마지막으로 교육 세션에 언제 참석하셨나요?",
      choices: {
        A: "지난달에 참석했습니다.",
        B: "직원들은 정기적으로 교육을 받습니다.",
        C: "교육 세션은 3시간 동안 진행되었습니다.",
      },
    },
    explanation:
      "When have(현재완료형) 의문문에서는 과거의 구체적인 시점이나 경험을 답변해야 합니다. A는 '지난달'이라는 구체적인 참석 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 37,
    questionText: "When have you completed the registration process?",
    choices: {
      A: "Many participants sign up for the event.",
      B: "I completed it yesterday.",
      C: "Registration requires personal identification.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "등록 절차를 언제 완료하셨나요?",
      choices: {
        A: "많은 참가자들이 행사에 등록합니다.",
        B: "어제 완료했습니다.",
        C: "등록에는 신분증이 필요합니다.",
      },
    },
    explanation:
      "When have(현재완료형) 의문문에서는 과거의 구체적인 시점이나 경험을 답변해야 합니다. B는 '어제'라는 구체적인 완료 시점을 명시하고 있습니다.",
  },
  {
    questionNumber: 38,
    questionText: "When the project is completed, what's the next step?",
    choices: {
      A: "We will present the final report to the client.",
      B: "The team is working on the final stage.",
      C: "The client requested additional features.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "프로젝트가 완료되면, 다음 단계는 무엇인가요?",
      choices: {
        A: "고객에게 최종 보고서를 발표할 예정입니다.",
        B: "팀이 마지막 단계를 진행하고 있습니다.",
        C: "고객이 추가 기능을 요청했습니다.",
      },
    },
    explanation:
      "When절이 포함된 복합 의문문에서는 조건(프로젝트 완료)이 충족된 후의 구체적인 계획이나 절차를 답변해야 합니다. A는 '최종 보고서 발표'라는 다음 단계를 명시하고 있습니다.",
  },
  {
    questionNumber: 39,
    questionText: "When the registration period ends, can I still apply?",
    choices: {
      A: "Many people register early.",
      B: "Late applications may be accepted with approval.",
      C: "The registration form is available online.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "등록 기간이 끝나면, 여전히 신청할 수 있나요?",
      choices: {
        A: "많은 사람들이 일찍 등록합니다.",
        B: "승인을 받으면 늦은 신청도 받아들여질 수 있습니다.",
        C: "등록 양식은 온라인으로 이용 가능합니다.",
      },
    },
    explanation:
      "When절이 포함된 복합 의문문에서는 조건(등록 기간 종료) 이후의 가능성이나 절차를 답변해야 합니다. B는 '승인을 통한 늦은 신청 가능성'이라는 구체적인 정보를 제공하고 있습니다.",
  },
  {
    questionNumber: 40,
    questionText: "When do you usually take your lunch break?",
    choices: {
      A: "I bring my lunch from home.",
      B: "The cafeteria serves healthy meals.",
      C: "Around 12:30 PM.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "보통 점심 시간을 언제 가지시나요?",
      choices: {
        A: "집에서 도시락을 가져옵니다.",
        B: "구내식당은 건강식을 제공합니다.",
        C: "오후 12시 30분경입니다.",
      },
    },
    explanation:
      "When do(현재형) 의문문에서는 정기적인 시간이나 일정을 답변해야 합니다. C는 '오후 12시 30분경'이라는 구체적인 일상적 점심 시간을 명시하고 있습니다.",
  },
];
